import { LIST_CATEGORY_PRODUCTS, IS_LOADING_LIST_COMPLETE_CATEGORY_PRODUCTS, LIST_COMPLETE_CATEGORY_PRODUCTS, EDIT_CATEGORY_PRODUCTS, CREATE_CATEGORY_PRODUCTS, DELETE_CATEGORY_PRODUCTS } from "../actions/types"

const initialState = {
    isLoadingCategoriesList: false,
    categoriesList: [],
    isLoadingCompleteCategoriesList: false,
    completeCategoriesList: [],
}

export default function (state = initialState, action) {
    switch (action.type) {
        case "IS_LOADING_PCATEGORIES":
            return { ...state, isLoadingCategoriesList: true }
        case LIST_CATEGORY_PRODUCTS:
            return { ...state, categoriesList: action.payload, isLoadingCategoriesList: false }
        case IS_LOADING_LIST_COMPLETE_CATEGORY_PRODUCTS:
            return { ...state, isLoadingCompleteCategoriesList: true }
        case LIST_COMPLETE_CATEGORY_PRODUCTS:
            return {
                ...state, completeCategoriesList: action.payload,
                isLoadingCompleteCategoriesList: false
            }
        case CREATE_CATEGORY_PRODUCTS:
            return { ...state, categoriesList: [...state.categoriesList, action.payload] }
        case EDIT_CATEGORY_PRODUCTS:
            const categoriesList = state.categoriesList.map(category => {
                if (category._id === action.payload._id) {
                    category.name = action.payload.name
                }
                return category;
            })

            return { ...state, categoriesList }
        case DELETE_CATEGORY_PRODUCTS:
            const categoryDelete = state.categoriesList.filter(category => {

                return category._id !== action.payload;
            })
            return { ...state, categoriesList: categoryDelete }
        default: return state
    }

}